import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Topbar from "./Topbar";
import SlideMenu from "./SlideMenu";
import Footer from "./Footer";
import NoiseOverlay from "./NoiseOverlay";
import QuickBuySheet from "../product/QuickBuySheet";

const Layout = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <>
      <NoiseOverlay />
      <Topbar />
      <SlideMenu />
      <main key={location.pathname} className="page-fade min-h-screen">
        {children}
      </main>
      <Footer />
      <QuickBuySheet />
    </>
  );
};

export default Layout;
